import { Grid, Paper } from "@mui/material";
import React from "react";
import "../../Styles/strategy.css";
import HeaderIcons from "../../Images/headericon.png";
import RebalancingOrders from "../Tables/RebalancingOrdersTable";

function Index() {
  return (
    <>
      <Grid item xs={12}>
        <Paper
          sx={{ p: 2, display: "flex", flexDirection: "column" }}
          elevation={1}
        >
          <div className="row rows" style={{ marginLeft: "2px" }}>
            <div className="col-1">
              <img src={HeaderIcons} alt="Header Icon" width="45" height="45" />
            </div>
            <div
              className="col-9"
              style={{ marginTop: "10px", marginLeft: "-3%" }}
            >
              <p style={{ fontSize: "20px", color: "#18275A" }}>
                {" "}
                Rebalancing Orders
              </p>
            </div>
          </div>
        </Paper>
      </Grid>
      <div
        style={{
          height: "calc(100vh - 100px)",
          overflowY: "auto",
          overflowX: "hidden",
          marginTop:"25px"
        }}
      >
        <Grid item xs={12}>
          <div className="row">
            <div className="col-12">
              <RebalancingOrders />
            </div>
          </div>
        </Grid>
      </div>
    </>
  );
}

export default Index;
